var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2500 557.7",
    viewBox: "0 0 2500 557.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 278.8v-278.8h653.8v557.7h-153.8v-403.9h-96.2v403.8h-153.8v-403.8h-96.2v403.8h-153.8zm730.8 0v-278.8h423.1v557.7h-153.9v-153.9h-115.4v153.8h-153.8zm269.2-67.3v-57.7h-115.4v115.4h115.4zm230.8 67.3v-278.8h153.8v211.5h134.6v-211.5h153.8v557.7h-153.8v-211.5h-134.6v211.5h-153.8zm519.2 0v-278.8h153.8v423.1h173.1v134.6h-326.9zm403.8 0v-278.8h346.2v134.6h-192.3v76.9h192.3v134.6h-192.3v76.9h192.3v134.6h-346.2z",
    fill: "#1e2a63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo04);
export default __webpack_public_path__ + "static/media/logo04.9e56503916975dc8bfd025d146290b86.svg";
export { ForwardRef as ReactComponent };